import { createContext } from "react";

export const GlobalContext = createContext({
    name: '',
    userId: ''
});